export default {
      id: "map-point-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#map-point",
      toString: function () {
        return this.url;
      }
    }